import { apiGet, apiPost } from '../../utilities/apiClient';
import { getSessionIds } from './_sessionIds';

type LocationPayload = {
  latitude: number;
  longitude: number;
  accuracy?: number | null;
  altitude?: number | null;
  heading?: number | null;
  speed?: number | null;
  timestamp: string;
  source?: string;
};


export const syncLocationData = (
  projectId: number | string,
  location: LocationPayload,
) => async (_dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return { success: false };
  try {
    const res = await apiPost(`/location/sync/${projectId}/${accountId}/${cognitoId}`, { location });
    return res;
  } catch (err: any) {
    return { success: false, message: err?.message };
  }
};

export const fetchLocationData = (projectId: number | string) => async (_dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return { success: false };
  try {
    const res = await apiGet(`/location/data/${projectId}/${accountId}/${cognitoId}`);
    return res;
  } catch (err: any) {
    return { success: false, message: err?.message };
  }
};

/**
 * The plan's appointments today that have a place, as geofence regions
 * (GET /location/data ?appointments=1). An ENTER is posted back through
 * syncLocationData and matched on the server; the region itself proves nothing.
 */
export const fetchAppointmentRegions = (projectId: number | string) => async (_dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return { success: false, regions: [] as AppointmentRegion[] };
  try {
    const res: any = await apiGet(`/location/data/${projectId}/${accountId}/${cognitoId}?appointments=1`);
    const regions = Array.isArray(res?.payload?.regions) ? res.payload.regions as AppointmentRegion[] : [];
    return { success: !!res?.success, regions };
  } catch (err: any) {
    return { success: false, regions: [] as AppointmentRegion[], message: err?.message };
  }
};

export type AppointmentRegion = {
  identifier: string;
  event_id: string;
  latitude: number;
  longitude: number;
  radius: number;
  starts_at: string;
  ends_at: string;
};

